import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'success-step',
  templateUrl: './success-step.component.html'
})
export class SuccessStepComponent {
  @Output()
  public backToLogin: EventEmitter<void>;

  constructor() {
    this.backToLogin = new EventEmitter<void>();
  }
}
